import { BankAccount } from "../../domain/types/banks/BankAccount";
import { firebaseDB } from "../firebase/firebase";
import {
  collection,
  doc,
  setDoc,
  deleteDoc,
  getDocs,
  query,
  where,
  onSnapshot,
  Unsubscribe,
} from "firebase/firestore";

export class FirestoreBankAccountRepository {
  private bankAccountsCollection = collection(firebaseDB, "bankAccounts");

  async create(bankAccount: BankAccount): Promise<void> {
    const bankAccountRef = doc(
      this.bankAccountsCollection,
      bankAccount.accountId,
    );
    console.debug("Creating bankAccount:", bankAccount);
    await setDoc(bankAccountRef, bankAccount);
  }

  async delete(accountId: string): Promise<void> {
    const bankAccountRef = doc(this.bankAccountsCollection, accountId);
    await deleteDoc(bankAccountRef);
  }

  async getBankAccountsByAppUserId(appUserId: string): Promise<BankAccount[]> {
    const q = query(
      this.bankAccountsCollection,
      where("appUserId", "==", appUserId),
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map((doc) => doc.data() as BankAccount);
  }

  observeBankAccountsByAppUserId(
    appUserId: string,
    onChanged: (accounts: BankAccount[]) => void,
    onError: (error: Error) => void,
  ): Unsubscribe {
    const q = query(
      this.bankAccountsCollection,
      where("appUserId", "==", appUserId),
    );

    return onSnapshot(
      q,
      (querySnapshot) => {
        const accounts = querySnapshot.docs.map(
          (doc) => doc.data() as BankAccount,
        );
        onChanged(accounts);
      },
      (error) => {
        onError(error);
      },
    );
  }
}
